import Vimeoinline from '@vimeo/player'

export default class VimeoVideo {
    init(): void {
        this.jsVimeoVideo()
    }

    jsVimeoVideo(): void {
        // https://stackoverflow.com/questions/24971297/how-to-hide-vimeo-controls
        if (document.querySelector('.play-pause')) {
            const videoPlayer = new Vimeoinline('myVideo')

            videoPlayer.on('play', function () {
                document.querySelector('.video-bg')?.classList.add('played')
            })

            videoPlayer.on('pause', function () {
                document.querySelector('.video-bg')?.classList.remove('played')
            })

            document.querySelector('.play-pause').addEventListener('click', function () {
                videoPlayer.play()
            })
        }
    }
}
